
import {
    FETCH_NEW_CONTENT_REQUEST,
    FETCH_NEW_CONTENT_SUCCESS,
    FETCH_NEW_CONTENT_FAILURE,
  } from '../../../Constants/actionTypes';
  
  const initialState = {
    loading: false,
    newContent: [],
    error: null,
  };
  
  const newContentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NEW_CONTENT_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_NEW_CONTENT_SUCCESS:
        return { ...state, loading: false, newContent: action.payload };
      case FETCH_NEW_CONTENT_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default newContentReducer;
  